import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { PathwaySummaries } from "../components/landing/PathwaySummaries";
import { JourneyTeaser } from "../components/landing/JourneyTeaser";
import { FAQTeaser } from "../components/landing/FAQTeaser";
import { Footer } from "../components/landing/Footer";
import { QuizResumeBanner } from "../components/landing/QuizResumeBanner";

export default function Landing() {
  return (
    <div
      data-testid="landing-page"
      className="min-h-screen bg-white"
      style={{ fontFamily: "Manrope, sans-serif" }}
    >
      <Navbar />
      <main>
        <Hero />
        <JourneyTeaser />
        <PathwaySummaries />
        <FAQTeaser />
      </main>
      <Footer />
      <QuizResumeBanner />
    </div>
  );
}
